import nativeHttp from '@/utils/native/http'

export interface VipInfo {
  tgId: number
  startTime: number // 开始时间/秒
  endTime: number
  effect: boolean // VIP 是否生效中 生效 true
  // 功能配置
  featureConfig: {
    vipNet: {
      value: 1
      editable: true
    }
    startAd: {
      value: 1
      editable: true
    }
    chatAd: {
      value: 1
      editable: true
    }
    didHot: {
      value: 1
      editable: true
    }
    discoveryAd: {
      value: 1
      editable: true
    }
    channel: {
      value: 1
      editable: true
    }
    web3: {
      value: 2
      editable: true
    }
    popNotification: {
      value: 1
      editable: true
    }
    popSwap: {
      value: 1
      editable: true
    }
    bayc: {
      value: 1
      editable: true
    }
    mineAd: {
      value: 1
      editable: true
    }
    did: {
      value: 1
      editable: true
    }
    redAd: {
      value: 1
      editable: true
    }
    mine: {
      value: 2
      editable: true
    }
    joinGroup: {
      value: 1
      editable: true
    }
  }
  freeNumber: false // 是否为实卡接码号码：true时不允许购买
  trialCardId: 1 // 用户当前剩余体验卡Id
  trialCardCount: 27 // 用户当前剩余体验卡数量
  rewardPercent: 6 // 1-100, 比如5代表5%
}

export function getVipInfo() {
  return nativeHttp.post<VipInfo>('user/vip/vipInfo', { h5: true })
}
